import { Basics } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Sizes } from '../_app/cuchillo/core/Sizes';
import { Functions } from '../_app/cuchillo/utils/Functions';
import Drag from './Drag';
import Line from './Line';
import Scene from '../3D/Scene';
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import Background from './Background';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Metrics } from '../_app/cuchillo/core/Metrics';

const POSITIONS = ['--pos-1', '--pos-2', '--pos-3', '--pos-4', '--pos-5', '--pos-6', '--pos-7', '--pos-8'];

export default class GridCanvas {
    static container;
    static wrapper;
    static holder;
    static canvas = document.createElement('canvas');
    static ctx = this.canvas.getContext('2d');

    static isRunning = false;
    static line;
    static drag;
    static background;

    static startBtn = GetBy.id('GridStart');
    static randomBtn = GetBy.id('GridRandom');
    static worksBtn = GetBy.id('GridWorks');
    static teamBtn = GetBy.id('GridTeam');
    static manifestoBtn = GetBy.id('GridManifesto');

    static items = [];
    static firstWork;
    static firstTeam;
    static firstManifesto;
    static oldCurrent = null;
    static current = null;
    static total_items = 0;

    static position = {
        center: { x: 0, y: 0 },
        line: { x: 0, y: 0 }
    };
    static target = {
        center: { x: 0, y: 0 },
        line: { x: 0, y: 0 }
    };
    static limit = { x0: 0, y0: 0, x1: 0, y1: 0 };
    static factorMove = { x: .025, y: .04 };
    static lerp = { x: 0.14, y: 0.1 };

    static calls = {
        first: (e) => this.first(e),
        works: (e) => this.works(e),
        team: (e) => this.team(e),
        manifesto: (e) => this.manifesto(e),
        random: (e) => this.random(e)
    }

    static init(container = document.body) {
        this.canvas.id = 'LineCanvas';
        this.canvas.width = this.canvas.offsetWidth * Sizes.RATIO;
        this.canvas.height = this.canvas.offsetHeight * Sizes.RATIO;
        this.container = container;
        this.wrapper = GetBy.selector('.__wrapper', this.container)[0];
        this.wrapper.appendChild(this.canvas);
        this.holder = GetBy.selector('.__holder', this.container)[0];

        let previousPosition = null;
        const items = GetBy.selector('.__item', this.container);
        for (let i = 0; i < items.length; i++) {
            // const dom = items[i]
            // const position = POSITIONS[Math.floor(Math.random() * 8)];
            // dom.classList.add(position);

            // const item = new Grid__Item(dom, this, this.calls);
            // this.items.push(item);
            // item.resize();
            const dom = items[i];

            let availablePositions = [...POSITIONS];

            // Evitem que --pos-1 i --pos-5 quedin juntes
            if (previousPosition === '--pos-1') {
                availablePositions = availablePositions.filter(p => p !== '--pos-5');
            }

            if (previousPosition === '--pos-5') {
                availablePositions = availablePositions.filter(p => p !== '--pos-1');
            }

            const position = availablePositions[Math.floor(Math.random() * availablePositions.length)];

            dom.classList.add(position);

            previousPosition = position;

            const item = new Grid__Item(dom, this, this.calls);
            this.items.push(item);
            item.resize();
        }

        this.total_items = this.items.length;

        this.buildChainsByType();
        this.setFirsts();
        this.reorderItems();

        this.drag = new Drag(this.wrapper, {
            dragStart: () => {
                WebGLSketch.dragging = true;

                this.target.center.x = this.position.center.x;
                this.target.center.y = this.position.center.y;

                this.lerp = { x: 0.14, y: 0.1 };
            },
            dragMove: n => {
                this.target.center.x = Maths.clamp(this.target.center.x + n.x, this.limit.x1, this.limit.x0);
                this.target.center.y = Maths.clamp(this.target.center.y + n.y, this.limit.y1, this.limit.y0);
            },
            dragEnd: () => {
                this.lerp = this.factorMove;

                // El navegador dispara un 'click' just després del mouseup que tanca
                // el drag. Netegem el flag al següent tick perquè aquell click el
                // capturi encara amb dragging=true i el raycaster l'ignori.
                setTimeout(() => { WebGLSketch.dragging = false; }, 0);
            }
        });
        this.drag.mount();

        Scene.update();

        Line.init(this.ctx, this.canvas);
        Line.directLineTo(this.items[0].line);

        this.addEventListeners();
    }

    static start(cb = () => { }) {
        if (this.isRunning) return;

        this.isRunning = true;

        this.goto(this.items[0]);
        WebGLSketch.show();

        cb();
    }

    static stop() {
        this.isRunning = false;
    }

    static reorderItems() {
        const items = Functions.arrayRandom([...this.items]);
        let order = 0;
        items.forEach(item => {
            item.dom.style.order = order++;
        });

        for (let i = 0; i < this.items.length; i++) {
            this.items[i].resize();
        }
    }

    static setFirsts() {
        this.firstWork = -1;
        this.firstTeam = -1;
        this.firstManifesto = -1;

        for (let i = 0; i < this.items.length; i++) {
            const item = this.items[i];

            if (item.type === 'project' && this.firstWork === -1) {
                this.firstWork = i;
            }

            if (item.type === 'team' && this.firstTeam === -1) {
                this.firstTeam = i;
            }

            if (item.type === 'manifesto' && this.firstManifesto === -1) {
                this.firstManifesto = i;
            }
        }
    }

    static buildChainsByType() {
        const works = [];
        const team = [];
        const manifesto = [];

        // Separem els items per tipus
        for (const item of this.items) {
            if (item.type === 'project') works.push(item);
            if (item.type === 'team') team.push(item);
            if (item.type === 'manifesto') manifesto.push(item);
        }

        // Funció per enllaçar circularment
        const linkCircular = (arr) => {
            if (arr.length <= 1) return;
            for (let i = 0; i < arr.length; i++) {
                const nextIndex = (i + 1) % arr.length;
                arr[i].next = arr[nextIndex];
            }
        };

        this.items[0].next = manifesto[0] || this.items[1];
        linkCircular(works);
        linkCircular(team);
        linkCircular(manifesto);
    }

    static addEventListeners() {
        this.startBtn.addEventListener(Basics.clickEvent, this.calls.first);
        this.randomBtn.addEventListener(Basics.clickEvent, this.calls.random);
        this.worksBtn.addEventListener(Basics.clickEvent, this.calls.works);
        this.teamBtn.addEventListener(Basics.clickEvent, this.calls.team);
        this.manifestoBtn.addEventListener(Basics.clickEvent, this.calls.manifesto);
    }

    static removeEventListeners() {
        this.startBtn.removeEventListener(Basics.clickEvent, this.calls.first);
        this.randomBtn.removeEventListener(Basics.clickEvent, this.calls.random);
        this.worksBtn.removeEventListener(Basics.clickEvent, this.calls.works);
        this.teamBtn.removeEventListener(Basics.clickEvent, this.calls.team);
        this.manifestoBtn.removeEventListener(Basics.clickEvent, this.calls.manifesto);
    }

    static random(e) {
        e.stopPropagation();

        const rand = Math.floor(Math.random() * this.total_items);
        const item = this.items[rand];
        const nextItem = item.next;
        this.goto(nextItem);
    }

    static first(e) {
        e.stopPropagation();

        const first = this.items[0];
        this.goto(first);
    }

    static team(e) {
        e.stopPropagation();
        const item = this.items[this.firstTeam];
        this.goto(item);
    }

    static works(e) {
        e.stopPropagation();
        const item = this.items[this.firstWork];
        this.goto(item);
    }

    static manifesto(e) {
        e.stopPropagation();
        const item = this.items[this.firstManifesto];
        this.goto(item);
    }

    static next(__index) {
        const item = this.items[__index];
        const nextItem = item.next;
        if (!nextItem) return;
        this.goto(nextItem);
    }

    static directGoto(__item) {
        if (this.current) {
            this.current.hide();
        }

        this.current = __item;
        this.current.show();

        this.position.center.x = this.target.center.x = this.current.center.x;
        this.position.center.y = this.target.center.y = this.current.center.y;
        this.position.line = this.target.line = this.current.line;

        Line.directLineTo(this.current.line);

        this.setActive();
    }

    static goto(__item) {
        if (this.current) {
            this.current.hide();
            this.oldCurrent = this.current;
        }

        this.current = __item;
        this.current.show();

        this.target.center = this.current.center;
        this.target.line = this.current.line;

        Line.lineTo(this.current.line);

        this.setActive();
    }

    static setActive() {
        if (this.current.index === this.firstManifesto) this.manifestoBtn.classList.add('--active');
        else this.manifestoBtn.classList.remove('--active');

        if (this.current.index === this.firstTeam) this.teamBtn.classList.add('--active');
        else this.teamBtn.classList.remove('--active');

        if (this.current.index === this.firstWork) this.worksBtn.classList.add('--active');
        else this.worksBtn.classList.remove('--active');

        if (this.current.index === 0) this.startBtn.classList.add('--active');
        else this.startBtn.classList.remove('--active');
    }

    static loop() {
        this.position.center.x = Maths.lerp(this.position.center.x, this.target.center.x, this.lerp.x);
        this.position.center.y = Maths.lerp(this.position.center.y, this.target.center.y, this.lerp.y);

        WebGLSketch.moveCamera({ x: -this.position.center.x, y: this.position.center.y });

        Line.goto(this.position.center);
        Line.loop();
    }

    static resize() {
        this.canvas.width = this.canvas.offsetWidth * Sizes.RATIO;
        this.canvas.height = this.canvas.offsetHeight * Sizes.RATIO;

        this.limit.x0 = Metrics.WIDTH * .5;
        this.limit.y0 = Metrics.HEIGHT * .6;
        this.limit.x1 = -(this.holder.getBoundingClientRect().width - Metrics.WIDTH * .5);
        this.limit.y1 = -(this.holder.getBoundingClientRect().height - Metrics.HEIGHT * .6);

        for (let i = 0; i < this.items.length; i++) {
            this.items[i].resize();
        }

        Background.resize();
        Scene.resize();
        WebGLSketch.resize();

        if (!this.isRunning) return;

        if (this.oldCurrent) Line.pointToPoint(this.oldCurrent.line, this.current.line);
    }

    static dispose() {
        this.stop();

        this.drag.dispose();
        Line.dispose();

        Scene.dispose();
        WebGLSketch.dispose();
        Background.dispose();
    }
}

export class Grid__Item {
    dom;
    scroller;
    box;
    type;
    index;
    circle;

    coords = {
        center: {
            x: 0,
            y: 0
        },
        line: {
            x: 0,
            y: 0
        }
    }

    get center() { return this.coords.center; }
    get line() { return this.coords.line; }

    constructor(__dom, __scroller) {
        this.dom = __dom;
        this.scroller = __scroller;
        this.box = GetBy.class('__box', __dom)[0];
        this.index = parseInt(this.box.dataset.index);

        this.type = this.box.dataset.type;
    }

    show() { }

    hide() { }

    resize() {
        const nextBtn = GetBy.selector('[data-next]', this.box)[0];

        if (nextBtn) {
            const canvasRect = this.scroller.container.getBoundingClientRect();
            const boxRect = this.box.getBoundingClientRect();

            const nextRect = nextBtn.getBoundingClientRect();

            const circleBtn = GetBy.selector('[data-next] .circle', nextBtn)[0];
            const circleRect = circleBtn.getBoundingClientRect();

            // Punt central de la box (centre X, centre Y)
            const absX = (boxRect.left + boxRect.width / 2) - canvasRect.width / 2;
            const absY = (boxRect.top + boxRect.height / 2) - canvasRect.height / 2;

            // Punt final de la caixa
            const lineY = nextRect.top + nextRect.height;
            const lineX = circleRect.right - circleRect.width / 2;

            // Coordenades relatives al centre del container
            this.coords = {
                center: {
                    x: -absX,
                    y: -absY
                },
                line: {
                    x: lineX,
                    y: lineY
                }
            }
        }
    }
}